import React from 'react';
import { Tabs, Tab } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { tokens } from '../theme';

// Switches between the two pages built on the multi-bookmaker scan
export default function BetsTabs() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <Tabs
      value={pathname === '/value' ? '/value' : '/arbitrage'}
      onChange={(_, v) => navigate(v)}
      sx={{ mb: 3, mt: -1, borderBottom: `1px solid ${tokens.border}`, '& .MuiTabs-indicator': { height: 3, borderRadius: 3 } }}
    >
      <Tab value="/arbitrage" label="Arbitrage" />
      <Tab value="/value" label="Value bets" />
    </Tabs>
  );
}
